export interface Tomo {
  number: string;
  title: string;
  intro: string;
  points: string[];
}

export interface Bono {
  tag: string;
  title: string;
  description: string;
  value: string;
}

export interface Testimonial {
  quote: string;
  name: string;
  location: string;
  role?: string;
  avatar?: string;
}

export interface Faq {
  question: string;
  answer: string;
}

export const AVATARS = {
  sofia: 'https://cdn.magicpatterns.com/patterns/generated-images/a08a0962-1eea-4d08-ae08-98bdfbbfb6f1.jpg',
  carolina: 'https://cdn.magicpatterns.com/patterns/generated-images/889491d3-8578-4257-bc2b-72de27e1b178.jpg',
  valentina: 'https://cdn.magicpatterns.com/patterns/generated-images/566f78fc-b045-4390-a3df-9a47a35dfe08.jpg',
};

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/e7acf215-7cd5-41ba-bc4d-f140cff02d0e.jpg';
export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/u4YnCExnvh15QBKqr1Hiu5/Firefly_Gemini_Flash_ponele_un_fondo_acorde_a_la_estetica_y_haccelo_mas_rosa_bebe,_formato_4-5_368228-Photoroom.png';

export const HERO_STATS = [
  { value: '+500', label: 'Profes confían' },
  { value: '7+5', label: 'Tomos + Bonos' },
  { value: '4.9/5', label: 'Calificación' },
  { value: '360°', label: 'Sistema completo' },
];

export const HERO_BADGES = [
  '7 Tomos',
  '60+ Clases listas',
  '5 Bonos incluidos',
  'PDF digital',
  'Acceso inmediato',
  'Todos los niveles',
];

export const TOP_TESTIMONIALS: Testimonial[] = [
  {
    quote:
      'Organicé todo el año en una tarde. Ahora tengo cada clase pensada, secuenciada y adaptada para todos mis grupos. Nunca más el domingo de pánico.',
    name: 'Sofía M.',
    location: 'Buenos Aires',
    role: 'Profe de Yoga en estudio propio',
    avatar: AVATARS.sofia,
  },
  {
    quote:
      'Las secuencias con progresión real por nivel cambiaron todo. Mis alumnas avanzaron más en 2 meses que en todo el año anterior.',
    name: 'Carolina R.',
    location: 'Rosario',
    role: 'Profe de Yoga en centro de bienestar',
    avatar: AVATARS.carolina,
  },
  {
    quote:
      'Adapto una misma postura a 3 niveles distintos en minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo.',
    name: 'Valentina F.',
    location: 'Córdoba',
    role: 'Profe de Yoga grupal e individual',
    avatar: AVATARS.valentina,
  },
];

export const PAIN_POINTS = [
  'Llegás a la clase sin saber exactamente qué secuencia vas a dar hoy.',
  'Tus alumnos no progresan porque no tenés una estructura clara.',
  'Sentís que repetís siempre las mismas 10 o 15 posturas.',
  'Te cuesta adaptar la clase cuando hay alumnos de distintos niveles.',
  'No sabés cómo organizar un mes completo de clases sin improvisar.',
  'Querés verte más profesional, pero no tenés un sistema claro.',
  'Terminás planificando a último momento, con cansancio y presión.',
  'Te gustaría cobrar mejor, retener más alumnos y mostrar una propuesta sólida.',
];

export const SYSTEM_STATS = [
  { value: '7 Tomos', label: 'Material ordenado para enseñar con claridad.' },
  { value: '420+', label: 'Páginas de contenido estructurado.' },
  { value: '60+', label: 'Clases completas listas para dar.' },
];

export const YOGA_STYLES = [
  'Hatha',
  'Vinyasa',
  'Yin',
  'Restaurativo',
  'Yoga Terapéutico',
  'Poblaciones Especiales',
];

export const SYSTEM_TOPICS = [
  'Planificación',
  'Posturas',
  'Progresión',
  'Adaptaciones',
  'Fidelización',
  'Crecimiento Profesional',
];

export const LEVELS = [
  'Principiante',
  'Intermedio',
  'Avanzado',
  'Prenatal y postnatal',
  'Adultos mayores',
  'Yoga terapéutico',
  'Clases grupales',
  'Clases individuales',
  'Online y presencial',
];

export const TOMOS: Tomo[] = [
  {
    number: '01',
    title: 'Fundamentos que Transforman',
    intro:
      'Para instructoras que quieren enseñar con autoridad, base sólida y una mirada profesional.',
    points: [
      'Historia del yoga aplicada a la clase moderna',
      'Las 8 ramas del yoga explicadas para enseñar',
      'Tipos de yoga: Hatha, Vinyasa, Yin y Restaurativo',
      'Cómo presentarte como instructora con autoridad',
      'Glosario esencial en sánscrito',
      'Clases base completas listas para dar',
      'Objetivos, desarrollo, cierre y cueings',
      'Checklist pre clase y durante la clase',
    ],
  },
  {
    number: '02',
    title: 'Anatomía en el Mat',
    intro: 'Para entender el cuerpo en movimiento y enseñar con mayor seguridad.',
    points: [
      'Anatomía práctica para profes de yoga',
      'Principales grupos musculares usados en clase',
      'Movilidad, estabilidad y alineación',
      'Cómo observar compensaciones frecuentes',
      'Correcciones simples y seguras',
      'Errores comunes en posturas populares',
      'Cuidado de columna, rodillas, hombros y caderas',
      'Lenguaje simple para explicar el cuerpo',
    ],
  },
  {
    number: '03',
    title: 'Biblioteca de Posturas',
    intro: 'Tu banco de asanas organizado para no repetir siempre lo mismo.',
    points: [
      'Posturas de pie y sentadas',
      'Torsiones, flexiones y extensiones',
      'Equilibrios e inversiones adaptadas',
      'Posturas restaurativas',
      'Beneficios principales',
      'Contraindicaciones generales',
      'Variaciones por nivel',
      'Cueings listos para usar',
    ],
  },
  {
    number: '04',
    title: 'Secuencias y Clases Resueltas',
    intro: 'Para abrir el PDF y tener la clase lista.',
    points: [
      'Clases completas de Hatha Yoga',
      'Clases completas de Vinyasa Yoga',
      'Secuencias para fuerza',
      'Secuencias para movilidad',
      'Secuencias para flexibilidad',
      'Clases de apertura de caderas',
      'Clases para espalda y columna',
      'Inicio, desarrollo, pico y cierre',
    ],
  },
  {
    number: '05',
    title: 'Yoga Suave, Yin y Restaurativo',
    intro:
      'Para trabajar con alumnos que necesitan calma, profundidad y adaptación.',
    points: [
      'Clases suaves listas para dar',
      'Secuencias de Yin Yoga',
      'Secuencias restaurativas',
      'Uso de apoyos y elementos',
      'Respiración y relajación guiada',
      'Propuestas para estrés y tensión corporal',
      'Adaptaciones para distintos cuerpos',
      'Cierres de clase más profesionales',
    ],
  },
  {
    number: '06',
    title: 'Poblaciones Especiales y Adaptaciones',
    intro: 'Para sentirte más segura cuando el grupo no es homogéneo.',
    points: [
      'Adaptaciones para adultos mayores',
      'Yoga prenatal y postnatal',
      'Alumnos principiantes absolutos',
      'Alumnos con baja movilidad',
      'Molestias frecuentes',
      'Alternativas sin frenar la clase',
      'Cómo manejar grupos mixtos',
      'Variantes Nivel 1, Nivel 2 y Nivel 3',
    ],
  },
  {
    number: '07',
    title: 'Planificación, Fidelización y Crecimiento Profesional',
    intro: 'Para dejar de vivir clase a clase y empezar a trabajar con sistema.',
    points: [
      'Planificación mensual de clases',
      'Organización trimestral y anual',
      'Progresión real para tus alumnos',
      'Cómo retener más alumnos',
      'Cómo mejorar la experiencia de clase',
      'Cómo presentar tus servicios con más valor',
      'Ideas para talleres y clases especiales',
      'Estrategias para redes sociales',
    ],
  },
];

export const BONOS: Bono[] = [
  {
    tag: 'BONO 1',
    title: '100 Cues Verbales Listos',
    description:
      'Indicaciones claras para guiar mejor cada postura, corregir sin invadir y sostener una clase más fluida.',
    value: '$12.000',
  },
  {
    tag: 'BONO 2',
    title: 'Planificador Mensual de Clases',
    description:
      'Organizá tus clases por objetivos, niveles, focos corporales y progresión semanal.',
    value: '$12.000',
  },
  {
    tag: 'BONO 3',
    title: 'Secuencias Express de 30 Minutos',
    description:
      'Clases cortas y efectivas para alumnas con poco tiempo, clases online o sesiones particulares.',
    value: '$12.000',
  },
  {
    tag: 'BONO 4',
    title: 'Meditaciones Guiadas',
    description:
      'Guiones listos para cierres de clase, respiración, relajación, calma mental y conexión corporal.',
    value: '$12.000',
  },
  {
    tag: 'BONO 5',
    title: 'Kit Profesional para Alumnas y Redes',
    description:
      'Fichas, seguimiento, ideas de contenido, textos para redes y recursos para comunicarte mejor.',
    value: '$12.000',
  },
];

export const CAPABILITIES = [
  'Planificar clases completas sin empezar desde cero.',
  'Tener secuencias listas para distintos objetivos y niveles.',
  'Adaptar posturas para grupos heterogéneos.',
  'Guiar con más seguridad usando cues claros.',
  'Organizar tu mes, trimestre y año de clases.',
  'Evitar repetir siempre lo mismo.',
  'Mejorar la experiencia de tus alumnas.',
  'Mostrar una propuesta más profesional.',
  'Ahorrar horas de planificación cada semana.',
  'Sentirte más segura entrando a cada clase.',
];

export const WITHOUT_SYSTEM = [
  '3 a 5 horas por semana planificando desde cero.',
  'Siempre las mismas posturas.',
  'Clases improvisadas a último momento.',
  'Alumnos que no ven progresión.',
  'Grupos mixtos difíciles de manejar.',
  'Dudas al adaptar posturas.',
  'Cierres de clase repetidos o improvisados.',
  'Menor percepción profesional.',
  'Más cansancio mental antes de enseñar.',
];

export const WITH_SYSTEM = [
  '10 minutos para elegir y adaptar tu clase.',
  '60+ clases listas para usar.',
  'Secuencias organizadas por objetivo y nivel.',
  'Progresión clara durante todo el año.',
  'Variantes para distintos alumnos.',
  'Biblioteca de posturas y cues listos.',
  'Meditaciones y cierres guiados.',
  'Sistema profesional para enseñar mejor.',
  'Más claridad, seguridad y tranquilidad.',
];

export const RESULTS_TESTIMONIALS: Testimonial[] = [
  {
    quote:
      'Compré un domingo a la noche. El lunes entré al estudio con el plan exacto de la clase. Las clases listas son exactamente lo que necesitaba para mis grupos de principiantes.',
    name: 'Sofía M.',
    location: 'Buenos Aires',
  },
  {
    quote:
      'La parte de poblaciones especiales me cambió todo. Ahora puedo adaptar mejor sin sentir que estoy improvisando.',
    name: 'Carolina R.',
    location: 'Rosario',
  },
  {
    quote:
      'Las secuencias de Vinyasa me ahorraron horas. Antes tardaba toda la noche armando una clase. Ahora tengo estructura y claridad.',
    name: 'Valentina F.',
    location: 'Córdoba',
  },
  {
    quote:
      'Los cues verbales eliminaron el silencio incómodo en clase. Ahora tengo indicaciones precisas y mis alumnas se sienten mucho más guiadas.',
    name: 'Luciana P.',
    location: 'Tucumán',
  },
  {
    quote:
      'La planificación mensual me ayudó a retener más alumnas. Sienten que hay un camino y no clases sueltas.',
    name: 'Marcela G.',
    location: 'Mendoza',
  },
  {
    quote:
      'Los guiones de meditación me salvaron los cierres. Mis clases ahora terminan con una sensación mucho más profesional.',
    name: 'Laura V.',
    location: 'Santa Fe',
  },
];

export const FAQS: Faq[] = [
  {
    question: '¿Cómo recibo Yoga 360 después de comprar?',
    answer:
      'Después de realizar el pago, recibís el acceso al material digital para descargar y usar de inmediato.',
  },
  {
    question: '¿Sirve para profes con poca experiencia?',
    answer:
      'Sí. Yoga 360 está pensado para instructoras que quieren tener una estructura clara, incluso si recién están empezando a dar clases.',
  },
  {
    question: '¿Sirve para profes avanzadas?',
    answer:
      'También. Si ya tenés experiencia, te ayuda a ahorrar tiempo, organizar mejor tu año y sumar más variedad a tus clases.',
  },
  {
    question: '¿Es editable?',
    answer:
      'El material está pensado para usar como guía profesional. Podés adaptarlo a tu estilo, a tus alumnas y a tu forma de enseñar.',
  },
  {
    question: '¿Sirve para clases individuales y grupales?',
    answer: 'Sí. Incluye recursos para ambos formatos.',
  },
  {
    question: '¿Sirve si tengo alumnos de distintos niveles?',
    answer:
      'Sí. Incluye variaciones, adaptaciones y formas de organizar grupos heterogéneos.',
  },
  {
    question: '¿Los bonos están incluidos?',
    answer:
      'Sí. La oferta única de Yoga 360 incluye los 7 tomos y los 5 bonos estratégicos.',
  },
  {
    question: '¿Tiene garantía?',
    answer: 'Sí. Tenés 7 días de garantía para revisar el material sin riesgo.',
  },
];
